import React from 'react';
import { TrendingUp, ChevronDown, ChevronUp } from 'lucide-react';

const StatCard = ({ title, value, change, icon: Icon, loading, description, isExpanded, onToggle }) => (
  <div 
    className="bg-white rounded-lg shadow-md p-6 border border-gray-100 cursor-pointer transition-all duration-200 hover:shadow-lg" 
    onClick={onToggle}
  >
    {loading ? (
      <div className="animate-pulse space-y-3">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-8 bg-gray-200 rounded w-1/2"></div>
      </div>
    ) : (
      <>
        <div className="flex items-center justify-between mb-4">
          <span className="text-gray-600 font-medium">{title}</span>
          <Icon className="h-5 w-5 text-blue-600" />
        </div>
        <div className="space-y-2">
          <div className="text-2xl font-bold text-gray-900">{value}</div>
          {change !== null && change !== undefined && !isNaN(change) && (
            <div className={`text-sm flex items-center gap-1 ${
              change > 0 ? 'text-red-600' : 'text-green-600'
            }`}>
              {change > 0 ? <TrendingUp size={16} /> : <TrendingUp size={16} className="rotate-180" />}
              {Math.abs(change)}% from previous period
            </div>
          )}
          {description && (
            <div className="text-sm text-gray-500">
              {typeof description === 'string' ? description : description}
            </div>
          )}
          <div className="flex items-center justify-end text-gray-400 hover:text-gray-600">
            {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </>
    )}
  </div>
);

export default StatCard;